import Reveal from "@/components/base/Reveal";
import { businessSolutions } from "@/mocks/home";

export default function BusinessSolutions() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
              <i className="ri-building-4-line" aria-hidden="true"></i>
              Para cada tipo de negócio
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Uma estrutura digital para diferentes tipos de negócios.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Cada empresa tem necessidades diferentes. Encontre a solução adequada para o seu
              segmento.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {businessSolutions.map((solution, index) => (
            <Reveal key={solution.title} delay={(index % 4) * 70}>
              <article className="group h-full overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="h-40 w-full overflow-hidden">
                  <img
                    src={solution.image}
                    alt={`Solução NXHOST para ${solution.title}`}
                    title={`${solution.title} — soluções digitais NXHOST`}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {solution.title}
                  </h3>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}